<template>
  <main class="flex-1 relative overflow-y-auto focus:outline-none" tabindex="0">
    <div class="my-6 max-w-1/6 mx-auto px-4 sm:px-6 lg:px-8">
      <div class="md:flex md:items-center md:justify-between">
        <div class="flex min-w-0">
          <svg-vue class="content-title-icon" icon="font-awesome.plus-circle-solid"></svg-vue>
          <h1 class="content-title">
            {{ $t('Create custom page') }}
          </h1>
        </div>
        <div class="mt-4 flex md:mt-0 md:ml-4">
          <router-link class="btn btn-app" to="/admin/custom-pages">
            {{ $t('Back') }}
          </router-link>
        </div>
      </div>
    </div>
    <div class="my-6 max-w-1/6 mx-auto px-4 sm:px-6 lg:px-8">
      <div class="content-card-body">
        <loading :status="loading"></loading>
        <form @submit.prevent="saveCutomPage">
          <div class="md:grid md:grid-cols-3 md:gap-6 px-4 py-5 sm:p-6">
            <div class="md:col-span-1">
              <h3 class="form-description-head">
                {{ $t('Custom page information') }}
              </h3>
              <p class="form-description-text">{{ $t('Enter information for new custom page') }}.</p>
            </div>
            <div class="mt-5 md:mt-0 md:col-span-2">
              <div class="grid grid-cols-3 gap-6">
                <div class="col-span-3">
                  <label class="form-label" for="title">{{ $t('Title') }}</label>
                  <div class="pt-1">
                    <input :placeholder="$t('Title')" class="form-input" id="title" required v-model="customPage.title" />
                  </div>
                </div>
                <div class="col-span-3">
                  <label class="form-label" for="content">{{ $t('Content') }}</label>
                  <input-wysiwyg id="content" v-model="customPage.content"></input-wysiwyg>
                </div>
                <div class="col-span-3">
                  <label class="form-label" for="status">{{ $t('Status') }}</label>
                  <div class="mt-1 flex rounded-md">
                    <input-switch :disabled-label="$t('The page is disabled')" :enabled-label="$t('The page is activated')" id="status" v-model="customPage.status"></input-switch>
                  </div>
                  <div class="form-description-text">
                    {{ $t('When the page is deactivated, it will not appear on portal,') }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="card-footer">
            <div class="inline-flex">
              <router-link class="btn btn-secondary shadow-sm rounded-md mr-4" to="/admin/custom-pages">{{ $t('Cancel') }}</router-link>
              <button class="btn btn-app shadow-sm rounded-md" type="submit">
                {{ $t('Save') }}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </main>
</template>
<script>
export default {
  name: 'new',
  metaInfo() {
    return {
      title: this.$i18n.t('Create custom page'),
    };
  },
  data() {
    return {
      loading: false,
      customPage: {
        title: null,
        content: '',
        status: false,
      },
    };
  },
  methods: {
    saveCutomPage() {
      this.loading = true;
      axios
        .post(route('custom-pages.store'), this.customPage)
        .then((response) => {
          this.$notify({
            title: this.$i18n.t('Success').toString(),
            text: response.data.message.toString(),
            type: 'success',
          });
          this.$router.push(`/admin/custom-pages/${response.data.customPage.id}/edit`);
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
};
</script>
